"use strict";

exports.__esModule = true;
exports.ElementControls = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _common = require("../../common");
var _Heading = require("../../../Core/Heading");
var _ControlGroups = require("../ControlGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "ElementControls__Container",
  componentId: "sc-1m48wwx-0"
})(["padding:20px;flex:1;"]);

/**
 * Shows controls for the selected element
 */
var ElementControls = exports.ElementControls = /*#__PURE__*/function (_Component) {
  function ElementControls() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementControls, _Component);
  var _proto = ElementControls.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      elementEditor = _this$props.elementEditor,
      controlPaths = _this$props.controlPaths;
    var selectedPath = elementEditor.selectedPath,
      widgets = elementEditor.widgets;
    var element = elementEditor.getElementAt(selectedPath);
    if (element === undefined) {
      return null;
    }
    var widget = (0, _common.getWidget)(widgets, element.type);
    if (widget === undefined) {
      return null;
    }
    var Fields = widget.components.Fields;
    return /*#__PURE__*/_react["default"].createElement(Container, {
      "data-testid": "ElementControls"
    }, !(widget != null && widget.ignoreHeading) ? /*#__PURE__*/_react["default"].createElement(_Heading.Heading, {
      level: 4
    }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: widget.icon,
      size: 20
    }), " ", widget.label) : null, /*#__PURE__*/_react["default"].createElement(Fields, {
      elementEditor: elementEditor,
      path: selectedPath,
      element: element
    }), /*#__PURE__*/_react["default"].createElement(_ControlGroups.ElementSizeControlGroup, {
      elementEditor: elementEditor,
      controlPaths: controlPaths
    }), /*#__PURE__*/_react["default"].createElement(_ControlGroups.ElementColorSourceControlGroup, {
      elementEditor: elementEditor,
      controlPaths: controlPaths
    }));
  };
  return ElementControls;
}(_react.Component);